import React from "react";
import PropTypes from "prop-types";

import { colorsDef } from "../utilities/colors";
import { textProps, textClass } from "../utilities/text";
import { colorsProps, colorsClass } from "../utilities/colors";
import { sizingProps, sizingClass } from "../utilities/sizing";
import { spacingProps, spacingClass } from "../utilities/spacing";
import { flexProps, flexClass } from "../utilities/flex";

import cn from "classnames";

const ButtonModalClose = (props) => {
  let {
    tag: Tag,
    className,
    children,
    onClick,
    size,
    block,
    outline,
    disabled,
    ...attributes
  } = props;

  let colors, sizing, spacing, text, flex;
  [text, attributes] = textClass(attributes);
  [colors, attributes] = colorsClass(attributes);
  [sizing, attributes] = sizingClass(attributes);
  [spacing, attributes] = spacingClass(attributes);
  [flex, attributes] = flexClass(attributes);

  size = size ? `btn-${size}` : "";
  block = block ? `btn-${block}` : "";

  return (
    <Tag
      {...attributes}
      className={cn(
        "btn",
        flex,
        text,
        size,
        block,
        sizing,
        spacing,
        disabled && "disabled",
        colors,
        outline && `btn-outline-${outline}`,
        className
      )}
      data-bs-dismiss="modal"
      onClick={onClick}
    >
      {children}
    </Tag>
  );
};

ButtonModalClose.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "lg"]),
  color: PropTypes.oneOf([...colorsDef]),
  block: PropTypes.bool,
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
  ...textProps(),
  ...sizingProps(),
  ...colorsProps(),
  ...spacingProps(),
  ...flexProps(),
};
ButtonModalClose.defaultProps = {
  tag: "button",
  className: "",
};

export default ButtonModalClose;
